import { Component, computed, input } from '@angular/core';
import { BubbleDirective, CommaPipe, Severity, TableColumn } from '@ui/aos-lib';
import { EventConfiguration } from '../../event-configuration.types';
import {
  EventConfigurationActivityType,
  EventConfigurationSeverity,
  EventConfigurationSeverityRule
} from '../../services/event-configuration-api.type';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';
import { TranslateModule } from '@ngx-translate/core';

const severityLevelCSSClassesMap = new Map<EventConfigurationSeverity, string>([
  [Severity.Critical, 'aos-severity-circle_critical'],
  [Severity.Notice, 'aos-severity-circle_notice'],
  [Severity.Severe, 'aos-severity-circle_severe'],
  [Severity.Warning, 'aos-severity-circle_warning']
]);

@Component({
  imports: [BubbleDirective, TranslateModule, CommaPipe],
  selector: 'aos-severity',
  styleUrl: './severity.component.scss',
  templateUrl: './severity.component.html'
})
export class SeverityComponent {
  item = input.required<EventConfiguration>();
  column = input.required<TableColumn>();

  protected isSeveritySingleMode = computed(
    () => this.item().trigger.activityType === EventConfigurationActivityType.Alarm
  );
  protected readonly severityLevel = computed(
    () => (this.item()[this.#severityField()] as EventConfigurationSeverityRule).severityLevel
  );
  protected readonly severityThreshold = computed(
    () => (this.item()[this.#severityField()] as EventConfigurationSeverityRule).threshold
  );
  protected readonly severityCSSClassModifier = computed(() => severityLevelCSSClassesMap.get(this.severityLevel()));
  protected readonly severityLevelKey = computed(
    () => translationKeysMap.get(this.severityLevel()) || this.severityLevel()
  );
  readonly #severityField = computed(() => this.column().field as 'critical' | 'notice' | 'severe' | 'warning');
}
